// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__DIhp4","chart":"Card_chart__QXC83","PrintCard":"Card_PrintCard__7pi7c"};